module.exports = __webpack_public_path__ + "img/ontario-logo-black.b678a18f.png";